import { render, staticRenderFns } from "./ListBuildings.vue?vue&type=template&id=9f1f5498"
import script from "./ListBuildings.vue?vue&type=script&lang=js"
export * from "./ListBuildings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports